import { STATUS_CLASSES, STATUS_LABELS } from "@/lib/api";

export const StatusBadge = ({ status, testId }) => (
  <span
    data-testid={testId || `status-badge-${status}`}
    className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold ${
      STATUS_CLASSES[status] || "bg-neutral-100 text-neutral-700 border-neutral-200"
    }`}
  >
    <span className="h-1.5 w-1.5 rounded-full bg-current" />
    {STATUS_LABELS[status] || status}
  </span>
);
